
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/affordable-college-storage-solutions",
      function () {
        return require("private-next-pages/affordable-college-storage-solutions/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/affordable-college-storage-solutions"])
      });
    }
  